<template>
    <div v-if="coupons && coupons.length > 0" class="p-2">
        <div class="text-center p-2 pb-4">
            <span class="h5 font-weight-light"><i class="fa fa-ticket"></i> {{transEdit('coupons')}}</span>
        </div>

        <div class="d-flex flex-column">
            <div class="flex-fill p-0 d-none d-md-flex justify-content-between flex-column flex-md-row font-weight-bold">
                <div class="col-md-3">{{transEdit('treatment')}}</div>
                <div class="col-md-2 text-left text-md-right">{{transEdit('value')}}</div>
                <div class="col-md-3 text-left text-md-right">{{transEdit('expirationdate')}}</div>
                <div class="col-md-1 text-left"></div>
                <div class="col-md-3 text-left"></div>
            </div>

            <template v-for="(coupon, index) in coupons">
                <div class="flex-fill p-0 d-flex justify-content-between flex-column flex-md-row border rounded mt-2 p-2">
                    <div class="col-md-3 font-weight-bold">{{getTreatmentName(coupon.treatment)}}</div>
                    <template v-if="coupon.price">
                        <div class="col-md-2 text-left text-md-right">{{coupon.price}} kr</div>
                    </template>
                    <template v-else>
                        <div class="col-md-2 text-left text-md-right"> - </div>
                    </template>
                    <div class="col-md-3 text-left text-md-right">{{getDate(coupon.expiration_date)}}</div>
                    <div class="col-md-1 text-left"></div>
                    <div class="col-md-3 text-right" :class="getCouponStyle(coupon)">
                        <span v-html="getCouponIcon(coupon)"></span>
                        {{getCouponNotice(coupon)}}</div>
                </div>
            </template>

        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'part'
        ],
        name: "customer-dash-coupons",
        computed: {
            coupons: function () {
                return this.part.coupons;
            }
        },
        methods: {
            getCouponIcon(coupon) {
                let status = this.couponStatus(coupon);
                switch(status) {
                    case 1:
                        return '<i class="fa fa-ban"></i>';
                        break;
                    case 2:
                        return '<i class="fa fa-warning"></i>';
                        break;
                    default:
                        return "";
                        break;
                }
            },
            getCouponStyle(coupon) {
                let status = this.couponStatus(coupon);
                switch(status) {
                    case 1:
                        return 'text-danger';
                        break;
                    case 2:
                        return 'text-warning';
                        break;
                    default:
                        return "";
                        break;
                }
            },
            getCouponNotice(coupon) {
                let status = this.couponStatus(coupon);
                switch(status) {
                    case 1:
                        return "Förfallen";
                        break;
                    case 2:
                        return "Boka snarast";
                        break;
                    default:
                        return "";
                        break;
                }
            },
            couponStatus(coupon) {
                let couponExpires = new moment(coupon.expiration_date);
                let now = moment();

                if (couponExpires < now) {
                    return 1;
                } else if (couponExpires < now.add(1, 'M')) {
                    return 2;
                } else {
                    return 3;
                }
            },
            getTreatmentName(treatment) {
                if (treatment) {
                    return treatment.name;
                } else {
                    return "Okänd behandlingstyp"
                }
            },
            getDate: function (dateTimestamp) {
                let tempDate = new Date(dateTimestamp);

                return tempDate.getYMD();
            },
            getHrsMins: function (dateTimestamp) {
                let tempDate = new Date(dateTimestamp);
                let hrsMins = tempDate.getHrsMins();

                return hrsMins;
            },
            getISODate: function (dateTimestamp) {
                let dateTimestampMillis = dateTimestamp * 1000;
                let tempDateString = this.getDate(dateTimestampMillis) + " " + this.getHrsMins(dateTimestampMillis);

                return tempDateString;
            }
        }
    }
</script>

<style scoped>

</style>